import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { GeneralNewsRouter } from '../../../general-news/types';

@injectable()
export class GeneralNewsRouterService implements GeneralNewsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/news`);
      return;
    }

    this.history.push({
      pathname: `/news`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToDetail(id: string) {
    this.history.push(`/news/${id}`);
  }

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }
}
